module.exports = __webpack_public_path__ + "img/2024big8.55c9d5e4.png";